<template>
  <div id="app">
    <topNav />
    <router-view class="rotView" :key="key" />
    <bottoms />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Router from "vue-router";
import topNav from "@/components/topNav";
import bottoms from "@/components/Bottoms";
import { getNavList } from "@/api/topNav.js";

export default {
  name: "App",
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
  components: { topNav, bottoms },
  created() {
    this.$store.dispatch("fetchNavList");
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
img {
  vertical-align: middle;
}
#app {
  max-width: 1898px;
  width: 100%;
  min-width: var(--content-min-width);
  margin: 0 auto;
}
.centerBox {
  position: relative;
  width: 100%;
  max-width: var(--content-max-width);
  min-width: var(--content-min-width);
  overflow: hidden;
}
.centerBox > .centBoxIn {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: var(--content-max-width);
}
.centerBox::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

:root {
  --content-width: 63%;
  --content-min-width: 1185px;
  --content-max-width: 1898px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue